(() => {
  const selector = '.ae-brands__disclosure';
  const desktop = () => window.matchMedia('(min-width: 1025px) and (hover: hover)').matches;
  document.addEventListener('pointerover', event => {
    const menu = event.target.closest(selector);
    if (menu && desktop() && !menu.contains(event.relatedTarget)) menu.open = true;
  });
  document.addEventListener('pointerout', event => {
    const menu = event.target.closest(selector);
    if (menu && desktop() && !menu.contains(event.relatedTarget) && !menu.contains(document.activeElement)) menu.open = false;
  });
  document.addEventListener('focusout', event => {
    const menu = event.target.closest(selector);
    if (menu && event.relatedTarget && !menu.contains(event.relatedTarget)) menu.open = false;
  });
  document.addEventListener('keydown', event => {
    const menu = event.target.closest(selector);
    if (menu && menu.open && event.key === 'Escape') {
      event.preventDefault();
      menu.open = false;
      menu.querySelector('summary').focus();
    }
  });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('.ae-brands__trigger');
    if (trigger && desktop() && event.detail > 0) {
      event.preventDefault();
      trigger.parentElement.open = true;
    }
    document.querySelectorAll(selector + '[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('shopify:block:select', event => {
    const menu = event.target.matches('.ae-brands') ? event.target.querySelector(selector) : null;
    if (menu) menu.open = true;
  });
  document.addEventListener('shopify:section:load', event => {
    if (!window.Shopify || !window.Shopify.designMode) return;
    const menu = event.target.querySelector(selector);
    if (menu) menu.open = true;
  });
})();
